import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditClass from '../../components/classes/FormAddEditClass';
import { useParams } from 'react-router-dom';
import { useGetClass } from '../../hooks/classes/useGetClass';
import LoadingPage from '../../components/global/LoadingPage';

const EditClass = () => {
    const { id } = useParams();
    const { classData, isLoading } = useGetClass(id);
    if (isLoading) return <LoadingPage />;
    return (<WrapperSection><GlobalBreadcrumbs /><FormAddEditClass isEdit currentData={classData?.data} /></WrapperSection>);
};
export default EditClass;
